import { useMemo, useState } from "react";
import TabItems from "../../../core/common/TabItems";
import Footer from "../../../core/common/Footer";
import useApi from "../../../core/customhook/useApi";
import Insufficiency from "./Insufficiency";
import ExtraCost from "./ExtraCost";
import StoppedCases from "./StoppedCases";
import { PageLoader } from "../../../core/common/loader/PageLoader";
import {
  DollarCircleOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
} from "@ant-design/icons";

type TabLabel =
  | "Insufficiency Checks"
  | "Additional Cost Approval"
  // | "Expired Insufficiencies"
  | "Stopped Checks";

type TabItem = {
  status_id: string;
  label: TabLabel;
  count: number;
};

const componentMap: Record<TabLabel, React.ComponentType<any>> = {
  "Insufficiency Checks": Insufficiency,
  "Additional Cost Approval": ExtraCost,
  // "Expired Insufficiencies": InsuffExpired,
  "Stopped Checks": StoppedCases,
};

const iconMap: Record<TabLabel, React.ReactNode> = {
  "Insufficiency Checks": <ExclamationCircleOutlined />,
  "Additional Cost Approval": <DollarCircleOutlined />,
  "Stopped Checks": <StopOutlined />,
};

const ManagerHrPendingAction = () => {
  const { data: tabCount, loading } = useApi(
    "/api/v1/agency/manager/hr-action-required/count",
    {
      method: "GET",
      autoCall: true,
    },
  );

  const dynamicTabs = useMemo(
    () =>
      ((tabCount?.data as TabItem[] | undefined) ?? []).map((item) => ({
        id: item.label,
        status_id: item.status_id ?? "",
        label: item.label,
        count: item.count,
        Component: componentMap[item.label],
      })),
    [tabCount],
  );

  // null = user hasn't clicked anything yet
  const [selectedTab, setSelectedTab] = useState<string | null>(null);

  // Use the selected tab only if it exists; otherwise fall back to the first tab
  const activeTabData =
    dynamicTabs.find((tab) => tab.label === selectedTab) ?? dynamicTabs[0];

  const activeTab = activeTabData?.label ?? "";
  const CaseMark = () => (
    <svg
      className="tcp-case-mark"
      viewBox="0 0 40 32"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="0" y="14" width="4" height="18" rx="1.5" />
      <rect x="9" y="8" width="4" height="24" rx="1.5" />
      <rect x="18" y="0" width="4" height="32" rx="1.5" />
      <rect x="27" y="10" width="4" height="22" rx="1.5" />
      <rect x="36" y="18" width="4" height="14" rx="1.5" />
    </svg>
  );

  return (
    <div className="page-wrapper">
      <div className="content p-2 p-md-3">
        {loading ? (
          <PageLoader />
        ) : (
          <>
            <div className="tcp-header-title-row d-flex gap-3 mb-3">
              <CaseMark />
              <div>
                <h4 className="tcp-title">HR Action Required</h4>
                <p className="tcp-subtitle">
                  Review screening checks requiring HR attention, resolve
                  insufficiencies, and take action on stopped checks.
                </p>
              </div>
            </div> 
            <ul className="invite-tabs">
              {dynamicTabs.map((tab) => (
                <li key={tab.id}>
                  <button
                    type="button"
                    className={`invite-btn ${
                      activeTab === tab.label ? "active" : ""
                    }`}
                    onClick={() => setSelectedTab(tab.label)}
                  >
                    <span className="d-flex align-items-center justify-content-center gap-2">
                      {iconMap[tab.label]}
                      <span>{tab.label}</span>
                    </span>

                    {typeof tab.count === "number" && (
                      <span className="d-block fw-semibold">{tab.count}</span>
                    )}
                  </button>
                </li>
              ))}
            </ul>

            <div className="mt-3">
              {activeTabData?.Component && (
                <activeTabData.Component status_id={activeTabData.status_id} />
              )}
            </div>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default ManagerHrPendingAction;

// import { useEffect, useState } from "react";
// import TabItems from "../../../core/common/TabItems";
// import Footer from "../../../core/common/Footer";
// import useApi from "../../../core/customhook/useApi";
// import Insufficiency from "./Insufficiency";
// import ExtraCost from "./ExtraCost";
// import InsuffExpired from "./InsuffExpired";
// import StoppedCases from "./StoppedCases";
// import { PageLoader } from "../../../core/common/loader/PageLoader";

// // Strict type
// type TabLabel =
//   | "Insufficiency Checks"
//   | "Additional Cost Approval"
//   | "Expired Insufficiencies"
//   | "Stopped Checks";

// type TabItem = {
//   status_id: string;
//   label: TabLabel;
//   count: number;
// };

// // FIX: Store COMPONENT, not JSX
// const componentMap: Record<TabLabel, React.ComponentType<any>> = {
//   "Insufficiency Checks": Insufficiency,
//   "Additional Cost Approval": ExtraCost,
//   "Expired Insufficiencies": InsuffExpired,
//   "Stopped Checks": StoppedCases,
// };

// const ManagerHrPendingAction = () => {
//   const { data: tabCount, loading } = useApi(
//     "/api/v1/agency/manager/hr-action-required/count",
//     {
//       method: "GET",
//       autoCall: true,
//     },
//   );

//   //  Build tabs with Component reference
//   const dynamicTabs =
//     (tabCount?.data as TabItem[] | undefined)?.map((item) => ({
//       id: item?.label,
//       status_id: item?.status_id ?? "",
//       label: item?.label,
//       count: item?.count,
//       Component: componentMap[item.label], //  correct
//     })) ?? [];

//   const [activeTab, setActiveTab] = useState<string>("");

//   //  Set default tab
//   useEffect(() => {
//     if (dynamicTabs.length > 0 && !activeTab) {
//       setActiveTab(dynamicTabs[0].label);
//     }
//   }, [dynamicTabs]);

//   //  Restore from localStorage
//   useEffect(() => {
//     const storedTab = localStorage.getItem("active-hr-action-tab");
//     if (storedTab) {
//       setActiveTab(storedTab);
//     }
//   }, []);

//   const activeTabData = dynamicTabs.find((tab) => tab.label === activeTab);

//   return (
//     <div className="page-wrapper">
//       <div className="content p-2 p-md-3">
//          {loading ? <PageLoader />
//          : <><TabItems
//           tabList={dynamicTabs}
//           activeTab={activeTab}
//           handleClick={(d) => {
//             setActiveTab(d.label);
//             localStorage.setItem("active-hr-action-tab", d.label);
//           }}
//         />

//         <div className="mt-3">
//           {/* Render component with status_id */}
//           {activeTabData?.Component && (
//             <activeTabData.Component status_id={activeTabData?.status_id} />
//           )}
//         </div>
//         </>
// }
//       </div>

//       <Footer />
//     </div>
//   );
// };

// export default ManagerHrPendingAction;
